import React from 'react';

import AppointmentAttendanceCard from '@/ui/components/AppointmentAttendanceCard/AppointmentAttendanceCard';

import './styles.css';
import type { Props } from './types';

const EncounterAppointmentCard = ({ encounter }: Props) => {
  const { appointment, appointment_attendance, person } = encounter;

  if (!appointment || !appointment_attendance) return null;

  return (
    <AppointmentAttendanceCard
      attendance={appointment_attendance}
      personTimeZone={person?.time_zone ?? ''}
    />
  );
};

export default React.memo(EncounterAppointmentCard);
